<template>
  <div class="row">
    <div class="col-lg-12">
      <block-cntr :btitle="'Config the Gemport Reference'" style="height: 410px">
        <div class="form-inline">
          <span style="float: left">
            <div class="btn-group open">
              <div
                @click="clkAdd()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-plus page-tableaction"></i>
              </div>
              <div
                @click="clkDel()"
                class="btn"
                :class="{ disabled: false }"
                style="padding: 0px"
              >
                <i class="fa fa-trash-o page-tableaction"></i>
              </div>
            </div>
          </span>
        </div>

        <table class="table table-hover table-noneborder-top">
          <thead>
            <tr>
              <th width="40px">
                <input
                  type="checkbox"
                  v-model="isSelectAll"
                  @change="changeSelectAll()"
                  id="idSelectAllGem"
                />
                <label for="idSelectAllGem"></label>
              </th>
              <th
                v-for="(value, key) in uniqueGemportTable.title"
                :key="key"
                :title="value"
              >
                {{ value }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, index) in uniqueGemportTable.data"
              :key="row.gemport"
              :class="{ 'true:': true }"
              @click=""
            >
              <td width="40px">
                <div v-if="!row.isNew">
                  <input
                    type="checkbox"
                    v-model="row.selected"
                    :id="'idRowSelectGem' + index"
                  />
                  <label :for="'idRowSelectGem' + index"></label>
                </div>
              </td>
              <td>
                <div>{{ row.gemport }}</div>
              </td>
              <td>
                <div>{{ row.vlanProfile }}</div>
              </td>
              <td>
                <div>{{ row.usProfile }}</div>
              </td>
              <td>
                <div>{{ row.dsProfile }}</div>
              </td>
            </tr>
          </tbody>
        </table>

        <!--配置操作-->
        <div v-if="isShowAddTable">
          <dialog-box
            :btitle="'Gemport Edit'"
            style="min-height: 100%"
            @close="isShowAddTable = false"
            :closeButton="true"
          >
            <form class="form-horizontal" role="form">
              <div class="form-group">
                <label class="col-sm-3 control-label" for="gemPort"
                  >Gemport</label
                >
                <div class="col-sm-5" :class="{ 'has-error': checkGemPort() }">
                  <input
                    type="text"
                    class="form-control"
                    id="gemPort"
                    v-model="gemportForm.gemPort"
                    placeholder="INTEGER<1-1024>"
                    autocomplete="off"
                  />
                  <small
                    class="help-block"
                    :style="{
                      display: checkGemPort() ? 'block' : 'none',
                    }"
                    >{{ checkGemPort() }}
                  </small>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-3 control-label" for="vlanProfile"
                  >Vlan Profile</label
                >
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="vlanProfile"
                    v-model="gemportForm.vlanProfileId"
                  >
                    <option value="">None</option>
                    <option
                      v-for="data in vlanTable"
                      :key="data.profileId"
                      :value="data.profileId"
                    >
                      {{ data.profileId + ":" + data.profileName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="usProfile"
                  >Us Traffic Profile</label
                >
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="usProfile"
                    v-model="gemportForm.usProfileId"
                  >
                    <option value="">None</option>
                    <option
                      v-for="data in usTable"
                      :key="data.profileId"
                      :value="data.profileId"
                    >
                      {{ data.profileId + ":" + data.profileName }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-3 control-label" for="dsProfile"
                  >Ds Traffic Profile</label
                >
                <div class="col-sm-5">
                  <select
                    class="form-control"
                    id="dsProfile"
                    v-model="gemportForm.dsProfileId"
                  >
                    <option value="">None</option>
                    <option
                      v-for="data in dsTable"
                      :key="data.profileId"
                      :value="data.profileId"
                    >
                      {{ data.profileId + ":" + data.profileName }}
                    </option>
                  </select>
                </div>
              </div>

              <button
                type="button"
                class="btn btn-primary"
                style="
                  margin-left: 20%;
                  min-width: 77px;
                  color: #fff;
                  background-color: #008b8b;
                  border-color: #008080;
                "
                @click="clkApply()"
              >
                {{ "Apply" }}
              </button>
              <span style="margin-left: 10px">
                <button
                  type="button"
                  class="btn btn-default"
                  style="min-width: 77px"
                  @click="clkCancel()"
                >
                  {{ "Cancel" }}
                </button>
              </span>
            </form>
          </dialog-box>
        </div>
      </block-cntr>
    </div>

    <info-box :ibox="iBox"></info-box>
    <waiting-box visible="showWaitingBoxDiag" msg="'mWaitingMsg'"></waiting-box>
  </div>
</template>

<script>
import en from "../lang/en-US.js"
import BlockCntr from "./../components/BlockCntr.vue"
import InfoBox from "@/components/InfoBox.vue"
import DialogBox from "@/components/DialogBox"
import { get, post } from "@/utils/http.js"

export default {
  name: "uniqueGemport",
  components: {
    BlockCntr,
    InfoBox,
    DialogBox,
  },
  props: ["uniqueOnt"],

  data() {
    return {
      uniqueGemportTable: "",
      isShowAddTable: false,
      isSelectAll: false,
      iBox: {},
      gemportForm: {
        gemPort: "",
        vlanProfileId: "",
        usProfileId: "",
        dsProfileId: "",
      },
      vlanTable: "",
      usTable: "",
      dsTable: "",
    }
  },

  created() {
    this.loadUniqueGemport()
    this.loadvlanProfile()
    this.loadUsProfile()
    this.loadDsProfile()
  },

  methods: {
    loadUniqueGemport() {
      get("uniqueGemport?ontIndex=" + this.uniqueOnt)
        .then((res) => (this.uniqueGemportTable = res.data))
        .catch((err) => {
          this.uniqueGemportTable = en.uniqueGemportTable
        })
    },
    loadvlanProfile() {
      get("profilevlanpri")
        .then((res) => {
          this.vlanTable = res.data.data
        })
        .catch((err) => {})
    },
    loadUsProfile() {
      get("profileus")
        .then((res) => {
          this.usTable = res.data.data
        })
        .catch((err) => {})
    },
    loadDsProfile() {
      get("profileds")
        .then((res) => {
          this.dsTable = res.data.data
        })
        .catch((err) => {})
    },

    clkAdd() {
      this.isShowAddTable = true
      this.resetField()
      this.selectNull()
    },

    clkDel() {
      var delData = {}
      var list = []

      for (let i = 0; i < this.uniqueGemportTable.data.length; i++) {
        if (this.uniqueGemportTable.data[i].selected) {
          list.push({
            gemport: Number(this.uniqueGemportTable.data[i].gemport),
          })
        }
      }
      if (list.length == 0) {
        return
      }
      delData["ontid"] = this.uniqueOnt
      delData["gemportList"] = list
      post("uniqueGemportDelete", delData)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadUniqueGemport()
            this.showAlertBox("info", "Info", "Delete Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
    },
    clkCancel() {
      this.isShowAddTable = false
    },

    resetField() {
      var gemportFormTmp = {
        gemPort: "",
        vlanProfileId: "",
        usProfileId: "",
        dsProfileId: "",
      }
      this.gemportForm = gemportFormTmp
    },

    changeSelectAll() {
      for (let i = 0; i < this.uniqueGemportTable.data.length; i++) {
        if (this.isSelectAll) {
          this.uniqueGemportTable.data[i].selected = true
        } else {
          this.uniqueGemportTable.data[i].selected = false
        }
      }
    },

    selectNull() {
      for (let i = 0; i < this.uniqueGemportTable.data.length; i++) {
        this.uniqueGemportTable.data[i].selected = false
      }
      this.isSelectAll = false
    },
    clkApply() {
      var newGemport = {
        ontid: this.uniqueOnt,
        gemPort: Number(this.gemportForm.gemPort),
        vlanProfileId: Number(this.gemportForm.vlanProfileId),
        usProfileId: Number(this.gemportForm.usProfileId),
        dsProfileId: Number(this.gemportForm.dsProfileId),
      }
      for (let i = 0; i < this.uniqueGemportTable.data.length; i++) {
        if (newGemport.gemPort == this.uniqueGemportTable.data[i].gemport) {
          this.showAlertBox("warn", "Message", "This gemport has been created")
          return
        }
      }
      if (this.gemportForm.gemPort == "" || this.checkGemPort()) {
        this.showAlertBox("warn", "Message", "Invalid gemPort")
        return
      }
      if (this.gemportForm.vlanProfileId == "") {
        newGemport.vlanProfileId = -1
      }
      if (this.gemportForm.usProfileId == "") {
        newGemport.usProfileId = -1
      }
      if (this.gemportForm.dsProfileId == "") {
        newGemport.dsProfileId = -1
      }

      post("uniqueGemportConfig", newGemport)
        .then((res) => {
          console.log(res)
          if (
            res.data == undefined ||
            res.data.code === undefined ||
            res.data.code === 0
          ) {
            this.loadUniqueGemport()
            this.showAlertBox("info", "Info", "Config Successful!")
          } else this.showAlertBox("warn", "Message", res.data.msg)
        })
        .catch((err) => {
          this.showAlertBox("critical", "error", err)
        })
      this.isShowAddTable = false
      this.selectNull()
    },
    checkGemPort() {
      if (this.gemportForm.gemPort != "") {
        let gemPort = Number(this.gemportForm.gemPort)
        if (!isNaN(gemPort)) {
          if (gemPort < 1 || gemPort > 1024)
            return "gemPort must be in range 1-1024"
        } else return "gemPort must be in range 1-1024"
      }
      return null
    },

    /* 告警弹框 */
    showAlertBox(type, title, txt) {
      this.iBox = {
        visible: true,
        type: type, // info warn critical
        title: title,
        txt: txt,
        btxt: "Close",
      }
    },
  },
}
</script>
